import * as i0 from "@angular/core";
export let StatisticsDashboardComponent = /*#__PURE__*/(() => {
  class StatisticsDashboardComponent {
    static {
      this.ɵfac = function StatisticsDashboardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StatisticsDashboardComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: StatisticsDashboardComponent,
        selectors: [["ng-component"]],
        decls: 1,
        vars: 0,
        template: function StatisticsDashboardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0, "Bitte im Men\u00FC w\u00E4hlen.");
          }
        },
        encapsulation: 2
      });
    }
  }
  return StatisticsDashboardComponent;
})();